import { render, staticRenderFns } from "./LogoutConfirmModal.vue?vue&type=template&id=1b6360e9"
import script from "./LogoutConfirmModal.vue?vue&type=script&lang=js"
export * from "./LogoutConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./LogoutConfirmModal.vue?vue&type=style&index=0&id=1b6360e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports